import { post, get, request } from "./http.js";
//公共接口
/**
 * 登录
 * @param {*} data 
 * @returns 
 */
const webLogin = (data) => post("web/login", data);
/**
 * 获取当前用户信息
 * @param {*} data 
 * @returns 
 */
const webGetuserinfo = (data) => post("web/getuserinfo", data);
/**
 * 编辑账号信息
 * @param {*} data 
 * @returns 
 */
const webEditpcuser = (data) => post("web/editpcuser", data);
/**
 * 重置密码
 * @param {*} data 
 * @returns 
 */
const webResetpwd = (data) => post("web/resetpwd", data);
/**
 * 登录日志
 * @param {*} data 
 * @returns 
 */
const webLoginlog = (data) => post("web/loginlog", data);
/**
 * 劳动力总览
 * @param {*} data 
 * @returns 
 */
const webHome = (data) => post("web/home", data);
/**
 * 重点人群-已就业人员
 * @param {*} data 
 * @returns 
 */
const webWorkdata = (data) => post("web/workdata", data);
/**
 * 重点人群-未就业人员
 * @param {*} data 
 * @returns 
 */
const webNoworkdata = (data) => post("web/noworkdata", data);
/**
 * 重点人群-外出务工人员（已废弃）
 * @param {*} data 
 * @returns 
 */
const webGoshengdata = (data) => post("web/goshengdata", data);
/**
 * 重点人群-高校毕业生（已废弃）
 * @param {*} data 
 * @returns 
 */
const webStudentdata = (data) => post("web/studentdata", data);
/**
 * 采集信息列表
 * @param {*} data 
 * @returns 
 */
const webInfolist = (data) => post("web/infolist", data);
/**
 * 信息详情
 * @param {*} data 
 * @returns 
 */
const webInfodetail = (data) => post("web/infodetail", data);
/**
 * 采集信息编辑
 * @param {*} data 
 * @returns 
 */
const webEditinfo = (data) => post("web/editinfo", data);
/**
 * 得到文化程度
 * @param {*} data 
 * @returns 
 */
const webGetedu = (data) => post("web/getedu", data);
/**
 * 得到就业状态
 * @param {*} data 
 * @returns 
 */
const webGetworkstatus = (data) => post("web/getworkstatus", data);
/**
 * 得到就业方式（已废弃）
 * @param {*} data 
 * @returns 
 */
const webGetworkway = (data) => post("web/getworkway", data);
/**
 * 得到月工资收入
 * @param {*} data 
 * @returns 
 */
const webGetsalary = (data) => post("web/getsalary", data);
/**
 * 得到从事工种web/getworkway
 * @param {*} data 
 * @returns 
 */
const webGetworktype = (data) => post("web/getworktype", data);
/**
 * 得到就业行业
 * @param {*} data 
 * @returns 
 */
const webGethangye = (data) => post("web/gethangye", data);
/**
 * 得到未就业原因
 * @param {*} data 
 * @returns 
 */
const webGetnoworkreason = (data) => post("web/getnoworkreason", data);
/**
 * 得到就业创业地（已废弃）
 * @param {*} data 
 * @returns 
 */
const webGetjiuchuangaddr = (data) => post("web/getjiuchuangaddr", data);
/**
 * 得到所属人群（已废弃）
 * @param {*} data 
 * @returns 
 */
const webGettype = (data) => post("web/gettype", data);
/**
 * 得到劳动能力类型（已废弃）
 * @param {*} data 
 * @returns 
 */
const webGetlaodongtype = (data) => post("web/getlaodongtype", data);
/**
 * 得到人员类别
 * @param {*} data 
 * @returns 
 */
const webGetcate = (data) => post("web/getcate", data);
/**
 * 得到参保险种
 * @param {*} data 
 * @returns 
 */
const webGetcanbaotype = (data) => post("web/getcanbaotype", data);
/**
 * 得到就业主体类型
 * @param {*} data 
 * @returns 
 */
const webGetjiuyeqiyetype = (data) => post("web/getjiuyeqiyetype", data);
/**
 * 得到自主创业单位性质
 * @param {*} data 
 * @returns 
 */
const webGetcyxingzhi = (data) => post("web/getcyxingzhi", data);
/**
 * 得到政治面貌（已废弃）
 * @param {*} data 
 * @returns 
 */
const webGetmianmao = (data) => post("web/getmianmao", data);
/**
 * 得到户类型（已废弃）
 * @param {*} data 
 * @returns 
 */
const webGethutype = (data) => post("web/gethutype", data);
/**
 * 得到返乡原因（已废弃）
 * @param {*} data 
 * @returns 
 */
const webGetfanxiangreason = (data) => post("web/getfanxiangreason", data);
/**
 * 得到人口资源分类（已废弃）
 * @param {*} data 
 * @returns 
 */
const webGetziyuancate = (data) => post("web/getziyuancate", data);
/**
 * 得到技能证书类型（已废弃）
 * @param {*} data 
 * @returns 
 */
const webGetcrttype = (data) => post("web/getcrttype", data);
/**
 * 得到转移就业方式（已废弃）
 * @param {*} data 
 * @returns 
 */
const webGetzhuanyiway = (data) => post("web/getzhuanyiway", data);
/**
 * 得到转移就业产业类别（已废弃）
 * @param {*} data 
 * @returns 
 */
const webGetzhuanyichanye = (data) => post("web/getzhuanyichanye", data);
/**
 * 劳动力查询-动态筛选
 * @param {*} data 
 * @returns 
 */
const webSearchlist1 = (data) => post("web/searchlist1", data);
/**
 * 劳动力查询-报表统计
 * @param {*} data 
 * @returns 
 */
const webSearchlist2 = (data) => post("web/searchlist2", data);
/**
 * 采集分析-按街道统计
 * @param {*} data 
 * @returns 
 */
const webStreetdata = (data) => post("web/streetdata", data);
/**
 * 采集分析-按社区统计
 * @param {*} data 
 * @returns 
 */
const webShequdata = (data) => post("web/shequdata", data);
/**
 * 采集分析-采集目标
 * @param {*} data 
 * @returns 
 */
const webTargetdata = (data) => post("web/targetdata", data);
/**
 * 得到街道及社区
 * @param {*} data 
 * @returns 
 */
const indexGetstreetandshequ = (data) => post("index/getstreetandshequ", data);
/**
 * 得到乡镇街道及社区
 * @param {*} data 
 * @returns 
 */
const indexGetzhenstreetandshequ = (data) => post("index/getzhenstreetandshequ", data);

export default {
    webLogin,
    webGetuserinfo,
    webEditpcuser,
    webResetpwd,
    webLoginlog,
    webHome,
    webWorkdata,
    webNoworkdata,
    webGoshengdata,
    webStudentdata,
    webInfolist,
    webInfodetail,
    webEditinfo,
    webGetedu,
    webGetworkstatus,
    webGetworkway,
    webGetsalary,
    webGetworktype,
    webGethangye,
    webGetnoworkreason,
    webGetjiuchuangaddr,
    webGettype,
    webGetlaodongtype,
    webGetcate,
    webGetcanbaotype,
    webGetjiuyeqiyetype,
    webGetcyxingzhi,
    webGetmianmao,
    webGethutype,
    webGetfanxiangreason,
    webGetziyuancate,
    webGetcrttype,
    webGetzhuanyiway,
    webGetzhuanyichanye,
    webSearchlist1,
    webSearchlist2,
    webStreetdata,
    webShequdata,
    webTargetdata,
    indexGetstreetandshequ,
    indexGetzhenstreetandshequ,









}